import {BDFilter, BDRadioFilter} from '@brother-apps/brother-dealerapp-shared-lib';
import {Component, HostBinding, Input, forwardRef, ViewChild, ElementRef, OnInit} from '@angular/core';

import {EnumUtils} from '../../../utils/enum.utils';
import {IndustrySectorEnum} from '../../../enums/industry-sector.enum';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-branch-select',
    templateUrl: './branch-select.component.html',
    styleUrls: ['./branch-select.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => BranchSelectComponent),
        multi: true
    }
    ]
})
export class BranchSelectComponent implements ControlValueAccessor, OnInit {

    @Input() public group = 'branch-group';
    @Input() public label: string;

    @Input()
    public showValidation: boolean;
    @Input()
    public isError: boolean;

    public radios: BDFilter[] = [
        // tslint:disable:max-line-length
        new BDFilter(IndustrySectorEnum.INDUSTRIAL_CUSTOMER, EnumUtils.getKeyByValue(IndustrySectorEnum, IndustrySectorEnum.INDUSTRIAL_CUSTOMER)),
        new BDFilter(IndustrySectorEnum.HEALTH_SYSTEM, EnumUtils.getKeyByValue(IndustrySectorEnum, IndustrySectorEnum.HEALTH_SYSTEM)),
        new BDFilter(IndustrySectorEnum.PUBLIC_CLIENT, EnumUtils.getKeyByValue(IndustrySectorEnum, IndustrySectorEnum.PUBLIC_CLIENT)),
        new BDFilter(IndustrySectorEnum.FINANCIAL_SYSTEM, EnumUtils.getKeyByValue(IndustrySectorEnum, IndustrySectorEnum.FINANCIAL_SYSTEM))
    ];
    // tslint:enable:max-line-length

    public value: BDFilter;

    @HostBinding('class.force-form-validation-visibility')
    @Input()
    forceFormValidationVisibility = true;  // show required and so on

    @ViewChild('container', {static: true, read: ElementRef}) container: ElementRef;


    propagateChangeFn: any = () => {
    }
    onTouchedFn: any = () => {
    }
    public isIEMode: boolean;


    constructor() {
    }

    ngOnInit(): void {
        const agent = window.navigator.userAgent.toLowerCase();
        this.isIEMode = agent.indexOf('trident') > -1;
    }


    public getFaName(key: string) {
        const key2 = IndustrySectorEnum[key];

        switch (key2) {
            case IndustrySectorEnum.INDUSTRIAL_CUSTOMER:
                return 'industry';
            case IndustrySectorEnum.HEALTH_SYSTEM:
                return 'heartbeat';
            case IndustrySectorEnum.PUBLIC_CLIENT:
                return 'building';
            case IndustrySectorEnum.FINANCIAL_SYSTEM:
                return 'euro';
            default:
                return '';
        }

    }


    registerOnChange(fn: any): void {
        this.propagateChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    // setDisabledState(isDisabled: boolean): void {
    //     this.isDisabled = isDisabled;
    // }

    // gets value from outside and write it to component value
    writeValue(value: any): void {
        for (const radio of this.radios) {
            radio.selected = radio.internalName === value;
            if (radio.selected) {
                this.value = radio;
            }
        }

    }

    // calls propagateChangeFn function which write value out from this component to reactive field form

    public radioClicked(selectedRadio: BDRadioFilter): void {
        // console.log('selectedRadio', selectedRadio);

        if (this.value && this.value.label === selectedRadio.label) {
            return;
        }

        for (const radio of this.radios) {
            radio.selected = radio.label === selectedRadio.label;
            if (radio.selected) {
                this.value = radio;
            }
        }


        this.propagateChangeFn(this.value.internalName);
        this.onTouchedFn();
    }

    public onKeyDown(event: KeyboardEvent) {

        // console.log('onKeyDown');


        let step = 0;
        switch (event.key) {
            case 'ArrowUp':
                step = -1;
                break;
            case 'ArrowDown':
                step = 1;
                break;
        }

        if (step !== 0) {
            let index = +(this.value && this.radios.findIndex(value => value.label === this.value.label));

            if (index > -1) {
                this.value.selected = false;

                if (index === 0) {
                    index = this.radios.length;
                }
                this.value = this.radios[(index + step) % this.radios.length];
                this.value.selected = true;
            } else {
                this.value = this.radios[0];
                this.value.selected = true;
            }

            this.propagateChangeFn(this.value.internalName);
            this.onTouchedFn();

            // stop page scrolling for arrow keys if input is fully visible
            const windowHeight = window.innerHeight;
            const rect = this.container.nativeElement.getBoundingClientRect();

            if (rect.bottom + 10 < windowHeight) {
                event.preventDefault();
            }
        } else {

            let labelToSearchFor: IndustrySectorEnum = null;
            switch (event.key) {
                case 'i':

                    labelToSearchFor = IndustrySectorEnum.INDUSTRIAL_CUSTOMER;
                    break;
                case 'g':
                    labelToSearchFor = IndustrySectorEnum.HEALTH_SYSTEM;
                    break;
                case 'o':
                    labelToSearchFor = IndustrySectorEnum.PUBLIC_CLIENT;
                    break;
                case 'f':
                    labelToSearchFor = IndustrySectorEnum.FINANCIAL_SYSTEM;
                    break;
            }

            if (labelToSearchFor) {
                const index = this.radios.findIndex(value => value.label === labelToSearchFor);
                if (index > -1) {
                    if ( this.value) {
                        this.value.selected = false;
                    }
                    this.value = this.radios[index];
                    this.value.selected = true;

                    this.propagateChangeFn(this.value.internalName);
                    this.onTouchedFn();
                }
            }

        }




    }

    public onBlur() {
        this.onTouchedFn();
    }







}
